export { default } from "./Posts";
